import TableContextProvider from 'components/v2/Table/TableContextProvider';
import React from 'react';
import { useReportContext } from '../../reports/context/ReportContext';
import { Cell } from '@tanstack/react-table';

type Props = {
  excluded?: string[];
  keyPrefix?: string;
  itemDetailsAction?(item: any): void;
  itemHoverAction?(item: any): void;
  onCellClick?(args: { cell: Cell<any, unknown>; item: any }): void;
};

const ReportTableContextProvider = ({
  children,
  excluded = [],
  keyPrefix = '',
  itemDetailsAction,
  itemHoverAction,
  onCellClick,
}: React.PropsWithChildren<Props>) => {
  const { id, enabledAttributes, attributes } = useReportContext();

  const enabled = enabledAttributes.filter((name) => {
    return !excluded.includes(name);
  });

  const available = { ...attributes };
  excluded?.forEach((name) => delete available[name]);

  return (
    <TableContextProvider
      key={id}
      availableAttributes={available}
      attributes={enabled}
      keyPrefix={keyPrefix}
      itemDetailsAction={itemDetailsAction}
      itemHoverAction={itemHoverAction}
      onCellClick={onCellClick}
    >
      {children}
    </TableContextProvider>
  );
};

export default ReportTableContextProvider;
